import { render } from "./VUESchedaUtente.vue?vue&type=template&id=4518ab9a"
import script from "./VUESchedaUtente.vue?vue&type=script&lang=js"
export * from "./VUESchedaUtente.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__